<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          v-on:click="onClickButton"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <GarageAccreditedList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import GarageAccreditedList from '@/components/settings/test-registers/garageAccredited/GarageAccreditedList'
  import ActionButton from '@/components/button/ActionButton'

  export default {
    name: 'GarageAccredited',
    components: {
      PageTitle,
      ActionButton,
      PageRowWrapper,
      GarageAccreditedList
    },
    methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addgarageaccredited' })
    }
  }
  }
</script>
